import Resource from "./resource.js";
export class IdentityFederations extends Resource {
    /**
     * Identity Federation
     * https://www.keycloak.org/docs-api/11.0/rest-api/#_identity_providers_resource
     */
    find = this.makeRequest({
        method: "GET",
        path: "/instances",
    });
    findOne = this.makeRequest({
        method: "GET",
        path: "/instances/{internalId}",
        urlParamKeys: ["internalId"],
        catchNotFound: true,
    });
    update = this.makeUpdateRequest({
        method: "PUT",
        path: "/instances/{internalId}",
        urlParamKeys: ["internalId"],
    });
    create = this.makeRequest({
        method: "POST",
        path: "/instances",
        returnResourceIdInLocationHeader: { field: "id" },
    });
    del = this.makeRequest({
        method: "DELETE",
        path: "/instances/{id}",
        urlParamKeys: ["id"],
    });
    refresh = this.makeRequest({
        method: "POST",
        path: "/instances/{id}/refresh",
        urlParamKeys: ["id"],
    });
    constructor(client) {
        super(client, {
            path: "/admin/realms/{realm}/saml-federations",
            getUrlParams: () => ({
                realm: client.realmName,
            }),
            getBaseUrl: () => client.baseUrl,
        });
    }
    findMapperTypes = this.makeRequest({
        method: "GET",
        path: "/mapper-types",
    });
    findOneMapper = this.makeRequest({
        method: "GET",
        path: "/instances/{internalId}/mappers/{id}",
        urlParamKeys: ["internalId", "id"],
        catchNotFound: true,
    });
    findMappers = this.makeRequest({
        method: "GET",
        path: "/instances/{internalId}/mappers",
        urlParamKeys: ["internalId"],
    });
    createMapper = this.makeRequest({
        method: "POST",
        path: "/instances/{federationId}/mappers",
        urlParamKeys: ["federationId"],
        payloadKey: "identityProviderMapper",
        returnResourceIdInLocationHeader: { field: "id" },
    });
    updateMapper = this.makeUpdateRequest({
        method: "PUT",
        path: "/instances/{internalId}/mappers/{id}",
        urlParamKeys: ["internalId", "id"],
    });
    delMapper = this.makeRequest({
        method: "DELETE",
        path: "/instances/{internalId}/mappers/{id}",
        urlParamKeys: ["internalId", "id"],
    });
    updateFederationMapper = this.makeRequest({
        method: "POST",
        path: "/instances/{internalId}/mappers/{mapperId}/idp/{action}",
        urlParamKeys: ["internalId", "mapperId", "action"],
    });
}
